module.exports = __webpack_public_path__ + "assets/img/96c0d95b2750bfc7ff6188e9d05aebb6.png";